import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ToastNotification = ({ 
  isVisible, 
  type = 'info', 
  title, 
  message, 
  duration = 4000, 
  onClose 
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const getToastStyles = (type) => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-success/10 border-success/20',
          icon: 'CheckCircle',
          iconColor: 'text-success',
          titleColor: 'text-success',
          messageColor: 'text-success/80'
        };
      case 'error':
        return {
          bg: 'bg-destructive/10 border-destructive/20',
          icon: 'XCircle',
          iconColor: 'text-destructive',
          titleColor: 'text-destructive',
          messageColor: 'text-destructive/80'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10 border-warning/20',
          icon: 'AlertTriangle',
          iconColor: 'text-warning',
          titleColor: 'text-warning',
          messageColor: 'text-warning/80'
        };
      default:
        return {
          bg: 'bg-primary/10 border-primary/20',
          icon: 'Info',
          iconColor: 'text-primary',
          titleColor: 'text-primary',
          messageColor: 'text-primary/80'
        };
    }
  };

  if (!isVisible) return null;

  const styles = getToastStyles(type);

  return (
    <div className="fixed top-4 right-4 z-[1000] animate-in slide-in-from-right-full duration-300">
      <div className={`max-w-sm w-full border rounded-lg shadow-elevated p-4 ${styles?.bg}`}>
        <div className="flex items-start space-x-3">
          <Icon 
            name={styles?.icon} 
            size={20} 
            className={`${styles?.iconColor} flex-shrink-0 mt-0.5`} 
          />
          <div className="flex-1 min-w-0">
            {title && (
              <p className={`text-sm font-medium ${styles?.titleColor} mb-1`}>
                {title}
              </p>
            )}
            {message && (
              <p className={`text-sm ${styles?.messageColor}`}>
                {message}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            className={`flex items-center justify-center w-6 h-6 ${styles?.iconColor} hover:opacity-70 transition-smooth`}
          >
            <Icon name="X" size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToastNotification;